// Merchant-dashboard hosts (the deep-link requires the operator to be logged in).
const LIVE_DASHBOARD = 'https://manage.gocardless.com';
const SANDBOX_DASHBOARD = 'https://manage-sandbox.gocardless.com';

/**
 * Environment-aware GoCardless dashboard deep-link. Returns null (caller hides
 * the action) with no payment id or an unknown environment — never guess the
 * host, or a live payment could get a sandbox link.
 */
export const gocardlessPaymentUrl = (
  paymentId: string | null | undefined,
  environment: string | null | undefined,
): string | null => {
  if (!paymentId) return null;
  if (environment === 'live') return `${LIVE_DASHBOARD}/payments/${paymentId}`;
  if (environment === 'sandbox') return `${SANDBOX_DASHBOARD}/payments/${paymentId}`;
  return null;
};
